var scope_0 = require('/Users/mcruz/Documents/Developer/gatsby/appuro-tanoariacoelho-adrego-com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8482328905eb235c9ace71c6f676ec79.js').default;export default
        Object.assign({}, scope_0 )
    